import LayoutActividad from "../../../components/LayoutActividad";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";

import Imagen1 from "../../../images/modulo12/colonia.png";
import Imagen2 from "../../../images/modulo12/elijuega.png";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad7 = () => {
  const infoUnidad = modulo12.content[0];
  const infoAct = modulo12.content[0].activities[9];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titlePrev: `${modulo12.content[0].name}: ${modulo12.content[0].activities[8].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[8].path}`,
    titleNext: `${modulo12.content[0].name}: ${modulo12.content[0].activities[10].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[10].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>
      <div className="bg-light p-3 p-md-5 mt-5">
        <div className="row align-items-center">
          <div className="col-lg-8 col-12 p-4 p-md-3">
          <h2 className="mb-4">Antes y ahora</h2>

            <p>
              El Perú siempre ha sido un país de migrantes. Los antiguos
              peruanos buscaban en otros lugares lo que no encontraban en sus
              tierras.
            </p>
            <p>
              Los incas hacían que poblaciones enteras se mudaran de una región
              a otra. Así, en un mismo lugar se encontraba gente de origen
              diverso.
            </p>
            <p>
              Mientras los españoles gobernaban el Perú (o sea, durante la
              Colonia), en una misma ciudad o pueblo había{" "}
              <strong>gente diversa</strong>. Había, por ejemplo, españoles,
              mestizos, indios y afrodescendientes.
            </p>
          </div>
          <div className="col-lg-4 col-12 text-center p-2 p-lg-0">
            <img src={Imagen1} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-lg-3 col-12 text-center p-2 p-lg-0">
            <img src={Imagen2} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-lg-8 col-12 p-4 p-md-5">
            <p>
              Con el tiempo, las ciudades fueron creciendo. Por eso, hoy en día
              la mayoría de la población es urbana. Las ciudades se han
              convertido en un espacio de encuentro entre todos los peruanos.
            </p>
          </div>
        </div>
      </div>{" "}
      <GuiaDocente>
        <ul>
          <li>Lea el texto titulado Antes y ahora.</li>

          <li>
            Resalte que los procesos de migración nos permiten encontrar gente
            de origen diverso en un mismo lugar. Hay que enfatizar que la
            migración no es un fenómeno reciente y que se ha dado a lo largo de
            la historia. Para el caso de nuestro país, por ejemplo, se menciona
            la época incaica y la colonial.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
